import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=215f7eca&scoped=true"
import script from "./sideNav.vue?vue&type=script&lang=js"
export * from "./sideNav.vue?vue&type=script&lang=js"
import style0 from "./sideNav.vue?vue&type=style&index=0&id=215f7eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215f7eca",
  null
  
)

export default component.exports